import TriggeredByFlows from "components/TriggeredByFlows";
import { isFlowsTrigger } from "utils/flows";

type HistoryEntryActorProps = {
  actor: string;
};

const HistoryEntryActor = ({ actor }: HistoryEntryActorProps) => (
  <i>{isFlowsTrigger(actor) ? <TriggeredByFlows triggeredBy={actor} /> : actor}</i>
);

export default HistoryEntryActor;
